export const cameraIcon = require('../assets/camera.png');
export const fbIcon = require('../assets/facebook-icon.svg').default;
export const instaIcon = require('../assets/instagram-icon.svg').default;
export const xIcon = require('../assets/x-icon.svg').default;
export const linkedInIcon = require('../assets/linkedin-icon.svg').default;
export const youtubeIcon = require('../assets/youtube-icon.svg').default;
export const locationIcon = require('../assets/location_icon.png');
export const editIcon = require('../assets/edit_icon.png');
export const playIcon = require('../assets/play_icon.png');
export const editPortofolioIcon = require('../assets/edit_portofolio_icon.png');
export const deletePortofolioIcon = require('../assets/delete_portofolio_icon.png');
export const profileImg = require('../assets/profile_img.png');
export const profileBgImg = require('../assets/profile_bg.png');
export const portfolioImg = require('../assets/portfolio_img.png');
export const portfolioOneImg = require('../assets/portfolio_img_one.png');
export const portfolioTwoImg = require('../assets/portfolio_img_two.png');
export const portfoliothreeImg = require('../assets/portfolio_img_three.png');
export const portImg2 = require('../assets/portImg2.png');
export const img = require('../assets/image_ (5).png');
export const pdfImg = require('../assets/image_ (6).png');
export const plusIcon = require('../assets/image__arrow-path.png');
export const aboutImg = require('../assets/education_img.png');
export const profileLocationIcon = require('../assets/profile-location-icon.png');
export const imageUpload = require('../assets/image__upload.png');
export const fbookIcon = require("../assets/Facebook.png");
export const instagramIcon = require("../assets/Symbol.png");
export const uploadIcon = require("../assets/image_ (7).png");
export const successIcon = require("../assets/group_ (1).png");
export const audioIcon = require("../assets/music.png");
